/**
 * 错误收集
 */
import eventMessage from 'src/components/event-message';
import { ERROR_TYPE } from 'src/constant';
import EVENT_MSG_TYPE from 'src/constant/event-msg-type';
import { win } from 'src/global';
import safeInvoke from 'src/utils/safe-invoke';

function proxyConsole(fns: string[], cb: (fn: string, args: any[]) => void) {
  fns.forEach(fn => {
    const consoleFn = console[fn];
    console[fn] = function (...args: any[]) {
      consoleFn(...args);
      cb(fn, args);
    };
  });
}
export function collectJsError() {
  safeInvoke(win, win.addEventListener, 'error', (err) => {
    if (!err || !err.message) {
      return;
    }
    // Script error类错误处理
    if (/^Script error/i.test(err.message) && !err.filename) {
      eventMessage.publish({
        time: Date.now(),
        type: EVENT_MSG_TYPE.COUNT,
        data: { ecid: 'scriptError', ecbiz: 'uba' },
      });
      return;
    }
    eventMessage.publish({
      time: Date.now(),
      type: EVENT_MSG_TYPE.JSERROR,
      data: err,
    });
  }, true);
  safeInvoke(win, win.addEventListener, 'unhandledrejection', (err) => {
    eventMessage.publish({
      time: Date.now(),
      type: EVENT_MSG_TYPE.UNHANDLEDREJECTION,
      data: err,
    });
  });
  if(win.console) {
    // hbLogger.info('proxyConsole');
    proxyConsole(['error'], (type, args) => {
      if(type === 'error' && args.length > 0) {
        const error = new Error(`${ERROR_TYPE.ConsoleError}: ${args.join(' ')}`);
        // @ts-ignore
        error.consoleArgs = args;
        eventMessage.publish({
          time: Date.now(),
          type: EVENT_MSG_TYPE.CONSOLEERROR,
          data: error,
        });
      }
    });
  }
}
